module.exports = __webpack_public_path__ + "static/media/Pollo frito con Mayonesa de Chipotle.6bb91460.webp";